import * as React from 'react';
import { connect } from 'react-redux';

import * as types from '../types';
import Error500 from '../components/errors/Error500';
import NotFound from '../components/404';
import AppLogger from '../utils/logging';
const logger = AppLogger.createLogger();

export interface Props extends types.ErrorsState {
    children: React.ReactNode;
}

const mapStateToProps = (state: types.StoreState) => ({ ...state.errors });

class ErrorBoundary extends React.Component<Props, {}> {
    render() {
        const { status } = this.props;
        if (status === 500) {
            return <Error500 />;
        }
        if (status === 404) {
            return <NotFound />;
        }
        if (status > 200) {
            logger.warn(`unhandle #${status} error, show general error page`);
            return <div style={{ padding: '25px' }}>Something wrong, try reload page</div>;
        }
        return this.props.children;
    }
}

export default connect(mapStateToProps)(ErrorBoundary);
